import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type StatusBarStatsProps = ComponentPropsWithoutRef<'div'>;

export const StatusBarStats = memo(({ className, ...restOfProps }: StatusBarStatsProps) => {
  return <div className={cn('flex items-center gap-1 font-medium text-12 text-grey-11', className)} {...restOfProps} />;
});

StatusBarStats.displayName = 'StatusBarStats';
